import { authServiceApi } from "../../../app/authServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../types";
import {
  GetAllNotificationParamsType,
  GetAllNotificationResponse,
} from "./notification.type";

export const notificationApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotification: builder.query<
      CommonResponse<GetAllNotificationResponse>,
      GetQueryArgsType<GetAllNotificationParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllNotification,
        ...queryArgs,
      }),
      providesTags: ["GetAllNotification"],
    }),
    notificationStatus: builder.mutation({
      query: (data) => ({
        url: API_URL.notificationStatus,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllNotification"];
        return [];
      },
    }),
  }),
});

export const { useGetAllNotificationQuery, useNotificationStatusMutation } =
  notificationApi;
